export default "__VITE_ASSET__d77664a5__"